import { Card, Col, Modal, Row, Space, Typography } from 'antd';
import Meta from 'antd/lib/card/Meta';
import React, { useCallback, useEffect } from 'react';
import { MdOutlineDeviceThermostat } from 'react-icons/md';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { ITemperatureHistory, ITrackingHistoryState } from '../../model/TrackingHistoryModal';
import { useTrackingHistoryStore } from '../../stores/TrackingHistoryStore';
import LoadingModalComponent from '../CommonComponent/LoadingModalComponent';
const TitleComponent = ({ item }) => {
	return (
		<Row justify='space-between'>
			<Typography.Text>IMEI: {item?.imei}</Typography.Text>
			<Typography.Text>Name: {item?.deviceTypeName}</Typography.Text>
		</Row>
	)
}

type ITrackingTemperatureComponent = {
	isOpen: boolean,
	closeModal: () => void,
	data: string
}


export function RealtimetempratureComponent({ isOpen, closeModal, data }: Readonly<ITrackingTemperatureComponent>) {
	const { promiseInProgress } = usePromiseTracker({ area: 'Waybill-temperature-realtime-tracking-area' });
	const GetTemperatureHistoryByWayBillAction = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.GetTemperatureByWayBillAction)
	const ClearTemperatureStore = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.ClearTemperatureTrackingStore);
	const temperatureTrackingHistory: ITemperatureHistory[] = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.temperatureHistory)
	const getTrackingData = useCallback(() => {
		if (data) {
			ClearTemperatureStore();
			trackPromise(GetTemperatureHistoryByWayBillAction(data), 'Waybill-temperature-realtime-tracking-area');
		}
	}, [GetTemperatureHistoryByWayBillAction, data, ClearTemperatureStore])

	useEffect(() => {
		getTrackingData();
	}, [getTrackingData])

	return (
		<LoadingModalComponent isLoading={promiseInProgress}>
			<Modal maskClosable={false} open={isOpen} onOk={closeModal} title={`Realtime Temperature Monitoring Airway Bill - ${data}`} centered onCancel={closeModal} width={1200}>

				<Row className="" gutter={20}>
					{temperatureTrackingHistory?.map(item => (
						<Col span={5} key={item?.imei}>
							<React.Fragment key={item?.imei}>
								<Card key={item?.imei} title={<TitleComponent item={item} />}
									bordered={true} loading={false} size={'small'}
									className={''}>
									<Meta
										description={
											<Row justify='space-between' align='middle'>
												<Col span={24}>
													<Space size={'large'} >
														<MdOutlineDeviceThermostat size={35} />
														<Space direction='vertical'>
															{/* <Row justify='end'> */}
															<Row>
																<Typography.Title level={5} mark>temperature: {item?.temp}°C</Typography.Title>
																<Typography.Title level={5} >Humidity: {item?.humi}%</Typography.Title>
																<Typography.Title level={5} >Time: {item?.rtc}</Typography.Title>
															</Row>
														</Space>
													</Space>
												</Col>
											</Row>
										}
									/>
								</Card>
							</React.Fragment>
						</Col>
					))}
				</Row >
			</Modal>
		</LoadingModalComponent>
	)
}